import { type JsonLd } from 'json-ld-types';

import { type SmartLinkKind } from '@canvas/model/elements/smart-link';

import { hasAccess } from './smart-link-client.ts';

const extractPreviewHref = (data: JsonLd.Data.BaseData) => {
  if (!data.preview) {
    return;
  }

  if (typeof data.preview === 'string') {
    return data.preview;
  } else if (data.preview['@type'] === 'Link') {
    return data.preview.href;
  } else {
    // TODO - remove once Linking team fixes issue with typings for some embeds (EDM-565).
    const maybeHref = (data.preview as any).href;
    const maybeUrl = data.preview.url;
    return maybeHref || maybeUrl;
  }
};

export const extractSupportedViews = (
  data: JsonLd.Response<JsonLd.Data.BaseData>,
): SmartLinkKind[] => {
  const views: SmartLinkKind[] = ['block'];

  const embedUrl = extractPreviewHref(data.data as JsonLd.Data.BaseData);
  if (embedUrl) {
    views.push('embed');
  }

  if (hasAccess(data)) {
    views.push('inline');
  }
  return views;
};

export const extractAri = (data: JsonLd.Response | undefined): string | undefined => {
  // @ts-expect-error - atlassian:ari is not typed
  return data?.data?.['atlassian:ari'] as string | undefined;
};

export const extractPreviewPanelSupported = (
  data: JsonLd.Response | undefined,
): boolean | undefined => {
  return data?.meta?.['whiteboards:previewPanelSupported'] as boolean | undefined;
};

export const createUnauthorizedResponse = (
  url: string,
): JsonLd.Object<JsonLd.Meta.BaseMeta, JsonLd.Data.Document> => ({
  meta: {
    access: 'unauthorized',
    visibility: 'restricted',
  },
  data: {
    '@type': 'Document',
    url,
  } as JsonLd.Data.Document,
});
